import { API } from "@/services"

export const TRANSSCRIPTION_ENDPOINTS = {
  getGraph(params={}){
    return API.Axios.callstats.v1.request({
      url: `transcription/graph`,
      method: 'GET',
      params,
    })
  },
}